import { render } from "./enrolments-history-section.vue?vue&type=template&id=b567a730&ts=true"
import script from "./enrolments-history-section.ts?vue&type=script&lang=ts&external"
export * from "./enrolments-history-section.ts?vue&type=script&lang=ts&external"

import "./enrolments-history-section.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__